/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { stepBaggageAndPersonalItemsExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['descriptionOfItems',
    'descriptionOfItemsForDamaged',
    'specifiedItems',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `baggageAndPersonalItems.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const damagedLostExpenses = mapToDamagedLostExpense(data);
  const baggageDelayExpenses = mapToBaggageDelayExpense(data);
  return [...damagedLostExpenses, ...baggageDelayExpenses];
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const { areYouClaimingForDamagedLostOrStolenLuggage, areYouClaimingForBaggageDelay } = data;
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))
  ) {
    return list;
  }
  if ((areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true') && claimTypes !== undefined) {
    const code1 = expenseLookup.areYouClaimingForDamaged.claimCode;
    const code2 = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
    const damagedLostExpenses = mapToDamagedLostExpense(data);
    const baggageDelayExpenses = mapToBaggageDelayExpense(data);
    claimTypes.forEach(
      (item) => {
        if (item.claimCode === code1 && areYouClaimingForDamagedLostOrStolenLuggage === 'true') {
          const benefit = mapClaimExpensesLevelItem(item, 'Baggage/Personal Effects', damagedLostExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (item.claimCode === code2 && areYouClaimingForBaggageDelay === 'true') {
          const benefit = mapClaimExpensesLevelItem(item, 'Baggage Delay', baggageDelayExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  return list;
}

function mapToDamagedLostExpense(data) {
  if (data.areYouClaimingForDamagedLostOrStolenLuggage !== 'true' || data.descriptionOfItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForDamaged.claimCode;
  const expenses = [];

  data.descriptionOfItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayExpense(data) {
  if (data.areYouClaimingForBaggageDelay !== 'true' || data.descriptionOfItemsForDamaged.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
  const expenses = [];

  data.descriptionOfItemsForDamaged.forEach(
    (item) => {
      const expense = mapDelayItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateOfLoss, claimCode);
}

function mapDelayItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateWhenYourLuggageWasDelayed, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currentClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.item}`,
    dateOfExpense: itemDate,
    clientCost: item.amountClaimed,
    currency: item.currentClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    dateOfPurchase: item.dateOfPurchase,
    depreciationType: item.depreciationType,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuch || !item.currencyExpensesClaimed || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhom} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuch * -1}`,
    currency: item.currencyExpensesClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsDataMapper.js